import React from 'react';
import { Button, FormGroup, FormControl, FormLabel } from "react-bootstrap";
import config from "../config";
import { gapi } from 'gapi-script';
import axios from 'axios';
import { withRouter } from './withRouter'; // HOC to inject navigate and location

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      errors: '',
      showPasswordTxt: false
    };
    this.btn_submit = React.createRef();

    const username = localStorage.getItem('username');
    if (username) {
      this.props.navigate('/'); // React Router v6
    }
  }

  validateForm = () => {
    return this.state.username.length > 0 && this.state.password.length > 0;
  }

  setUsername = (event) => this.setState({ username: event.target.value });
  setPassword = (event) => this.setState({ password: event.target.value });

  handleSubmit = async (event) => {
    event.preventDefault();
    const btn_submit = this.btn_submit.current;
    btn_submit.setAttribute("disabled", true);

    const { username, password } = this.state;
    const aopaApiUrl = config.aopaApiUrl;
    const url = aopaApiUrl + 'login-user';
  
    try {
      const response = await axios.post(url, { username, password }, {
        headers: { 'Content-Type': 'application/json' }
      });

      const data = response.data;
      if (data.username) {
        localStorage.setItem('role', data.role);
        localStorage.setItem('user_id', data.user_guid);
        localStorage.setItem('username', username);
        localStorage.setItem('user_login_date', new Date().toLocaleString("en-US", { timeZone: "America/New_York" }));

        // Get user IP
        const ipRes = await fetch("https://api.ipify.org/?format=json");
        const ipData = await ipRes.json();
        localStorage.setItem('user_ip', ipData.ip);

        this.props.navigate('/');

      }else{
        btn_submit.removeAttribute("disabled");
        this.setState({ errors: 'Invalid username or password.' });
      }

    } catch (error) {
      console.log('Login error:', error.response);
      btn_submit.removeAttribute("disabled");
    }
  }

  showPassword = (type) => {
    this.setState({ showPasswordTxt: type });
  }

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <div className="card card-signin my-5">
              <div className="card-body">
                <h5 className="card-title text-center">Sign In</h5>

                {this.state.errors &&
                  <div className="alert alert-danger"> {this.state.errors} </div>
                }

                <form onSubmit={this.handleSubmit}>
                  <FormGroup>
                    <FormLabel>Username</FormLabel>
                    <FormControl
                      autoFocus
                      type="text"
                      onChange={this.setUsername}
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Password</FormLabel>
                    <FormControl
                      id="passwordField"
                      type={this.state.showPasswordTxt ? "text" : "password"}
                      onChange={this.setPassword}
                    />
                    <i
                      id="showPassword"
                      className={`fa ${this.state.showPasswordTxt ? "fa-eye" : "fa-eye-slash"}`}
                      aria-hidden="true"
                      onClick={() => this.showPassword(!this.state.showPasswordTxt)}
                    ></i>
                  </FormGroup>

                  <Button className='btn-block' disabled={!this.validateForm()} type="submit" ref={this.btn_submit}>
                    Login
                  </Button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Login);